var chunkToChildrenMap = {
	"_yarn___virtual___aircall-icons-virtual-b440630796_0_cache_aircall-icons-npm-0_5_1-40cd95cbcb-10af6e": [
		"Login"
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };